import graphql from '@/api/graphql'
import Queries from '@/api/graphql/queries'
import Mutations from '@/api/graphql/mutations'
import { Extractor } from '@/api/utils'

import router from '@/router'

const Methods = {
  get:
    resource =>
    (payload = {}, options = {}) => {
      let { query = payload.id ? resource : `${resource}s`, transform = Extractor, draft } = options

      return graphql.request(Queries[query], payload, draft).then(transform)
    },

  mutate:
    resource =>
    (payload = {}, options = {}) => {
      let { transform = Extractor, transformPayload = true, draft } = options

      let id = payload.id,
        data

      if (transformPayload) {
        let { id: extractedId, ...rest } = payload
        data = rest
      }

      let mutation = options.mutation || (payload.id ? `${resource}Update` : `${resource}Create`)

      return graphql
        .request(Mutations[mutation], transformPayload ? { id, data } : { ...payload }, draft)
        .then(transform)
    },

  delete:
    resource =>
    (payload = {}, options = {}) => {
      let { mutation = `${resource}Delete`, transform = Extractor, draft } = options

      return graphql.request(Mutations[mutation], payload, draft).then(transform)
    },
}

export { Methods }

export default function (resource, config = {}) {
  return {
    get: Methods.get(resource),
    mutate: Methods.mutate(resource),
    delete: Methods.delete(resource),
    ...config,
  }
}
